<template>
	<div
		class="am-input-text"
		:class="[
			{
				'is-focused': focused,
				'is-invalid': !valid && !value
			}
		]"
		>
		<transition name="input-label">
			<am-text class="am-input-text__label" type="caption" v-if="!value">
				{{ label }}
			</am-text>
		</transition>

		<input
			class="am-input-text__field"
			:type="type"
			:value="value"
			@input="$emit('input', $event.target.value)"
			@focus="focused = true"
			@blur="focused = false"
			@keydown="$emit('keydown', $event)"
			@keyup="$emit('keyup', $event)"
		>

		<am-icon
			class="am-input-text__icon"
			name="close"
			size="sm"
			@click.native="onClear"
		/>
	</div>
</template>

<script>
import AMText from '@/components/atoms/AMText'
import AMIcon from '@/components/atoms/AMIcon'

export default {
	components: {
		'am-icon': AMIcon,
		'am-text': AMText
	},

	props: {
		value: {
			type: String,
			default: null
		},
		type: {
			type: String,
			default: 'text'
		},
		label: {
			type: String,
			default: 'Hello World'
		},
		valid: {
			type: Boolean,
			default: true
		}
	},

	data: () => ({
		focused: false
	}),

	methods: {
		onClear() {
			this.focused = false
			this.$emit('input', '')
		}
	}
}
</script>

<style lang="scss">
.am-input-text{
	width: 100%;
	position: relative;
	display: flex;
	align-items: center;
	overflow: hidden;
	&:before{
		content: "";
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 1px;
		background: $c-light-brown;
		transition: background .2s $easeInOutQuad;
	}
	&__label{
		position: absolute;
		top: 50%;
		left: 0;
		transform: translate(0, -50%);
		color: darken($c-light-brown, 10%);
		transition: color .2s $easeInOutQuad;
		pointer-events: none;
	}
	&__field{
		flex: 1;
		border: 0;
		background: transparent;
		font-size: 16px;
		box-sizing: border-box;
		outline: none;
		border-radius: 0;
		height: 44px;
		color: $c-light-brown;
		transition: color .2s $easeInOutQuad;
		&:-webkit-autofill{
			-webkit-box-shadow: 0 0 0px 1000px white inset;	
		}
	}
	&__icon{
		flex-shrink: 0;
		opacity: 0;
		transition: .4s $easeOutBack;
		transform: rotate(90deg);
		cursor: pointer;
	}

	&.is-invalid{
		&:before{
			background: red;
		}
		.am-input-text{
			&__label,
			&__field,
			&__label{
				color: red;
			}
		}
	}

	&.is-focused{
		&:before{
			background: $c-brown;
		}
		.am-input-text{
			&__label{
				color: $c-brown;
			}
			&__field{
				color: $c-brown;
			}
			&__icon{
				opacity: 1;
				transform: rotate(0deg);
			}
		}
	}

	// Slide left
	.input-label-enter-active,
	.input-label-leave-active{
		transition: .3s $easeInOutQuad;
	}

	.input-label-enter,
	.input-label-leave-active{
		opacity: 0;
		transform: translate(-30px, -50%);
	}
}
</style>
